import React, { useState, useEffect, useContext } from 'react';
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table';
import { Col, Container, Row } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { GlobalContext } from '../../context/provider';
import numberbeautifuly from '../../../utils/numberbeautify';

const Income_report_list = () => {
    const { reportState, reportDispatch } = useContext(GlobalContext);
    return (
        <div dir='rtl'>
            <Container>
                <Row className='justify-content-md-center mt-5'>
                    <Col lg={11}>
                        <Table striped bordered hover size="lg" style={{ textAlign: 'center' }} >
                            <thead>
                                <tr>
                                    <th>ناوی کەس و مەبەستی داهات</th>
                                    <th>بڕی داهات</th>
                                    <th>ژمارەی پسوڵە</th>
                                    <th>بەروار</th>
                                    <th>تێبینی</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: 12 }}>
                                {reportState.income_report.map((lis) => (
                                    <tr style={{ cursor: 'pointer' }}>
                                        <td>{lis.boss_income_nameandpurpose}</td>
                                        <td>{numberbeautifuly(lis.boss_income_amount)} IQD</td>
                                        <td>{lis.boss_income_invoiceno}</td>
                                        <td>{lis.boss_income_date}</td>
                                        <td>{lis.boss_income_note}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Income_report_list